import { Slot } from "radix-ui";
import type { ButtonHTMLAttributes, Ref } from "react";

export type ButtonVariant = "primary" | "secondary" | "create" | "ghost" | "header";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** primary только у следующего шага, одна на экране; create у «Новий». */
  variant?: ButtonVariant;
  size?: "md" | "lg" | "icon";
  block?: boolean;
  /** Вид кнопки у ссылки или другого элемента (Radix Slot). */
  asChild?: boolean;
  ref?: Ref<HTMLButtonElement>;
}

export function Button({ variant = "secondary", size = "md", block, asChild, className, type, ...rest }: ButtonProps) {
  const Comp = asChild ? Slot.Root : "button";
  return (
    <Comp
      className={className ? `w-btn ${className}` : "w-btn"}
      data-variant={variant}
      data-size={size === "md" ? undefined : size}
      data-block={block ? "" : undefined}
      type={asChild ? undefined : (type ?? "button")}
      {...rest}
    />
  );
}
